(function() {
    'use strict';

    angular.module('stats')
        .controller('PreviewSubscriptionsModalController', PreviewSubscriptionsModalController);

    PreviewSubscriptionsModalController.$inject = ['lodashService', '$uibModalInstance', 'client', 'previewLoadingConst'];

    function PreviewSubscriptionsModalController(lodashService, $uibModalInstance, client, previewLoadingConst) {
        var self = this;
        self.client = client;
        self.close = close;
        self.previewLoading = true;
        self.pagesLoaded = 0;
        self.pagesLoadingText = previewLoadingConst.pagesLoadingText;

        function close() {
            self.client = null;
            // $uibModalInstance.close();
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
